import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { DrawApi } from '@apply/api';
import { NumericFormat } from 'react-number-format';

export interface IFinalizeDrawModalParameters {
    draw: DrawApi.IDraw;
    isOpen: boolean;
    closeCallback(): void;
    submittedFinalizedDrawCallback: (id: number) => void;
    applicationInsights: ApplicationInsights;
}

export const FinalizeDrawModal = ({
    draw,
    isOpen,
    closeCallback,
    submittedFinalizedDrawCallback,
    applicationInsights,
}: IFinalizeDrawModalParameters): React.ReactElement => {
    const drawApi = new DrawApi.DrawApi(applicationInsights);
    const [drawFee, set_drawFee] = useState<number | undefined>();

    const onClose = () => {
        set_drawFee(undefined);
        closeCallback();
    };

    return (
        <div>
            <Dialog
                open={isOpen}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                title='Finalize Draw'
                maxWidth='sm'
            >
                <div
                    className='page-header'
                    role='banner'
                >
                    <h1>Finalize Draw</h1>
                </div>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        After Finalizing you with not be able to edit the draw. <br />
                        <br />A notification will be sent to the borrower informing them of their draw being funded.
                    </DialogContentText>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div style={{ padding: '0 5px' }}>
                            Draw Fee:
                            <NumericFormat
                                style={{ width: 150 }}
                                thousandSeparator=','
                                prefix='$'
                                placeholder='$'
                                value={drawFee}
                                decimalScale={2}
                                allowNegative={false}
                                onValueChange={(values) => set_drawFee(values.floatValue)}
                                required={true}
                                isAllowed={(values) => {
                                    const value = values?.floatValue;
                                    return value === undefined || value === null || value >= 0;
                                }}
                            />
                        </div>
                    </div>
                    <hr />
                </DialogContent>
                <DialogActions>
                    <button
                        style={{ padding: 6, marginRight: 20 }}
                        type='button'
                        className='button primary'
                        disabled={!(drawFee !== undefined && drawFee !== null && drawFee >= 0)}
                        onClick={() => {
                            drawApi.finalizeDraw({
                                drawId: draw.id,
                                drawFee: drawFee,
                            });
                            submittedFinalizedDrawCallback(draw.id);
                        }}
                    >
                        Finalize
                    </button>
                    <button
                        style={{ padding: 6, marginRight: 20 }}
                        type='button'
                        className='button hollow'
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
